export default "/asset/tutorial-page2.44242b65.png";